// src/config.js
const config = {
  // apiBasePath: process.env.REACT_APP_API_BASE_PATH || 'http://localhost', // Default to localhost for development
  // apiBasePath: process.env.REACT_APP_API_BASE_PATH || 'https://arxis.local', // Default to localhost for development
  apiBasePath: process.env.REACT_APP_API_BASE_PATH || 'https://api.arxistechnologies.com',
};

export default config;

/**
 * turkey shoulder 10kg 
 * pp 20+
 * express square
 * hake 10kg
 * large croacker
 * chicken neck
 * CHICKEN H & LEG
 * gizzrd
 * 3L soy
 * 5l soy
 * 25l soy
 */